import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Option from './SwipeHorizontalOption';
import Feedback from './SwipeHorizontalFeedback';
import Prompt from '../multipleChoice/Prompt';
import Conversation from '../conversationDialog/ChildConversationDialog';
import BadgeCollect from '../badges/BadgeCollect';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from '../../../constants/appConstants';
import * as xAPIHelper from '../../../helpers/xAPIHelper';
import * as localStorage from '../../../localStorage/localStorage';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as componentConstants from '../../../constants/componentConstants';
import {MULTIPLE_CHOICE_REVIEW_CONFIG} from '../../../models/dialogModels';
import {TweenLite, CSSPlugin, Elastic, Bounce, Expo} from 'gsap';
import Draggable from 'gsap/Draggable';
import gsap from 'gsap-react-plugin';

class SwipeHorizontal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            initialised: false,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            options: this.props.screenObject.options,
            showOptions: false,
            hideOptions: false,
            setDrags: false,
            leftOption: {},
            rightOption: {},
            activeOption: {},
            locale: appHelper.getLocalData(this.props.screenObject),
            callbacks: {},
            responseData: {
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                asset_id: this.props.screenObject.asset_id,
                currentAttempt: 1,
                currentStatus: objectConstants.STATUS_NOT_STARTED,
                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                responses: [],
                latestResponse: {},
                scoring_type: this.props.screenObject.scoring_type
            },
            showFeedback: false,
            showResponse: false,
            questionChecked: false,
            currentlyChecked: false,
            checkAnswers: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            checkPostXAPIResponse: false,
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            focusedOption: this.props.screenObject.options[0],
            focusOnFeedback: false,
            optionCallbacks: {},
            updateFocus: false,
            showProgression: false,
            hideFeedback: false,
            progression_label: "",
            hasBadges: false,
            badgesCollected: false,
            animateBadge: true,
            canScrollToContinue:false,
            canScrolltoProgression: false,
            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            try_again_label: appHelper.getLocaleString("try_again_label"),
            progressionHandled: false,
            xApiResponseObj:{},
        };

        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.scrollToFeedback = this.scrollToFeedback.bind(this);
        this.scrollToSubmitBtn = this.scrollToSubmitBtn.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.scrollOptionsToTop = this.scrollOptionsToTop.bind(this);
        this.setActiveOption = this.setActiveOption.bind(this);
        this.getClass = this.getClass.bind(this);
        this.checkAnswers = this.checkAnswers.bind(this);
        this.hideOptions = this.hideOptions.bind(this);
        this.getSwipeClass = this.getSwipeClass.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.reattempt = this.reattempt.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.handleSkipFeedback = this.handleSkipFeedback.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.getOptionListClass = this.getOptionListClass.bind(this);
        this.onPromptRevealed = this.onPromptRevealed.bind(this);
        this.postXAPIResponse = this.postXAPIResponse.bind(this);
        this.getBgClass = this.getBgClass.bind(this);
        this.getSwipeContainerClass = this.getSwipeContainerClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.onPanelClick = this.onPanelClick.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.hasFeedbackToShow = this.hasFeedbackToShow.bind(this);
        this.setFocusedOption = this.setFocusedOption.bind(this);
        this.clearFocusedOption = this.clearFocusedOption.bind(this);
        this.getPrevOption = this.getPrevOption.bind(this);
        this.getNextOption = this.getNextOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.allowKeyAccessibility = this.allowKeyAccessibility.bind(this);
        this.getTabIndex = this.getTabIndex.bind(this);
        this.onKeyboardPanelClick = this.onKeyboardPanelClick.bind(this);
        this.onFocusOnFeedback = this.onFocusOnFeedback.bind(this);
        this.setOptionCallbacks = this.setOptionCallbacks.bind(this);
        this.setOptionFocus = this.setOptionFocus.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.handleResponseComplete = this.handleResponseComplete.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.scrollToContinue = this.scrollToContinue.bind(this);
        this.scrollToProgression = this.scrollToProgression.bind(this);
        this.checkResponses = this.checkResponses.bind(this);
    }

    componentDidMount() {

        if(localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.checkResponses();
        }else{
            this.getObjectStatus();
        }
        this.setCallbacks();
        this.setOptionCallbacks();
        this.randomiseOptions();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
        this.getAssets();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkObjectStatus: true
            });
        }
        if(this.state.lang !== nextProps.lang){
            let progression_label = "";
            if(this.state.progression_label === this.state.try_again_label){
                progression_label = appHelper.getLocaleString("try_again_label");
            }else if(this.state.progression_label ===  this.state.continue_label){
                progression_label = appHelper.getLocaleString("continue_label");
            }
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
                progression_label: progression_label,
                continue_label: appHelper.getLocaleString("continue_label"),
                try_again_label: appHelper.getLocaleString("try_again_label")
            });
        }
    }

    componentDidUpdate() {
        
        if(this.state.canScrolltoProgression){
            this.scrollToProgression();
        }
        if (this.state.setDrags) {
            this.enableDrag();
        }
        if (this.state.hideOptions) {
            this.hideOptions();
        }
        if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setReviewMode();
        }

        if (this.state.skipFeedback) {
            this.handleSkipFeedback();
        }

        if (this.state.checkObjectStatus) {
            this.getObjectStatus();
        }

        if (this.state.handleCompletion) {
            this.handleProgression();
        }

        if (this.state.checkAnswers) {
            this.checkAnswers();
        }
        if (this.state.checkPostXAPIResponse) {
            this.postXAPIResponse();
        }

        if (this.state.focusOnFeedback) {
            this.onFocusOnFeedback();
        }

        if (this.state.updateFocus) {
            this.setOptionFocus();
        }

        if(this.state.canScrollToContinue){
            this.scrollToContinue();
        }
    }

    getAssets() {
        let objectUserData = {};
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            let subScreenParent = this.props.callbacks.getSubScreenParent();
            let screen_id = this.props.callbacks.getScreenId();
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else if (this.state.isResourceObject) {
                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        }

        if (appHelper.isDefined(this.state.screenObject.audio)) {
            let audio = appHelper.getAudioAsset(this.state.screenObject.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`,
            };

            if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
                this.props.actions.setAudio(audioObj);
            }
        }

    }

    postXAPIResponse() {
        this.setState({checkPostXAPIResponse: false});
        let interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
            let category = {
                constant: componentConstants.SWIPE_HORIZONTAL,
                label: componentConstants.SWIPE_HORIZONTAL_LABEL
            };

            this.props.actions.postActvityStatement(screen, interactionData, category);
        }
    }

    handleSkipFeedback() {
        let latestResponse = appHelper.getLastItemOfArray(this.state.responseData.responses);
        let selectedOptions = [latestResponse.selectedOption.option_id];
        if (appHelper.isDefined(latestResponse.audio)) {
            let audio = appHelper.getAudioAsset(latestResponse.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`
            };

            this.props.actions.setAudio(audioObj);
        }
        let responseObj = {
            asset_id: this.state.screenObject.asset_id,
            selectedOptions: selectedOptions,
            kpis: latestResponse.selectedOption.kpis !== null ? latestResponse.selectedOption.kpis : []
        };
        this.props.callbacks.storeUserResponse(responseObj);

        this.setState({skipFeedback: false});
        if(!this.state.hasBadges) {
            let handleResponse = this.handleResponse;

            setTimeout(function () {
                handleResponse();
            }, 1000);
        }
    }

    checkResponses(){
        if(localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2){
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {

                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionData = xAPIHelper.getMultipleChoiceIds(params);

            this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                if (appHelper.isDefined(responseObj.statement.result.completion)) {
                    this.setState({
                        xApiResponseObj: Object.assign({},responseObj),
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            });
        }
    }

    getObjectStatus() {
        this.setState({checkObjectStatus: false});
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
            let screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
            if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                this.setState({
                    reviewMode: true,
                    propsUpdated: true,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    )
                });
            } else {
                let objectUserData = {};
                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                    let subScreenParent = this.props.callbacks.getSubScreenParent();
                    let screen_id = this.props.callbacks.getScreenId();
                    if (appHelper.isDefined(subScreenParent)) {
                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                    } else {
                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                    }
                }

                if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                    this.setState({
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            }
        }
    }

    setReviewMode(){
        let optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
        let kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
        if(appHelper.isDefined(kpiUserData)) {
            let optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
            let showResponse = false;

            if (appHelper.isDefined(optionDetails)) {
                let responses = [];
                let response = {
                    selectedOption: optionDetails.option
                };

                if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
                    showResponse = true;
                }

                let hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0;

                this.setState(
                    {
                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && optionDetails.option.enable_feedback,
                        hasBadges: hasBadges,
                        badgesCollected: hasBadges,
                        showFeedback: false,
                        handleCompletion: true,
                        propsUpdated: false,
                        showOptions: true,
                        questionChecked: true,
                        currentlyChecked: true,
                        showCheckBtn: false,
                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
                        showResponse: showResponse,
                        progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                responses: dataHelper.immutablePush(responses, response),
                                latestResponse: optionDetails.option
                            }
                        )
                    }
                );
            }
        }else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let responseObj = Object.assign({}, this.state.xApiResponseObj);

            if (appHelper.isDefined(responseObj.statement)) {
                let responseString = responseObj.statement.result.response;
                let choices = responseObj.statement.object.definition.choices;
                let optionResponse = xAPIHelper.getChoiceByDescription(choices,responseString);
                //let optionDetails = appHelper.getOptionByLabelName(responseString, this.state.screenObject.options);
                let optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
                if (appHelper.isDefined(optionDetails)) {
                    let showResponse = false;
                    let responses = [];
                    let response = {
                        selectedOption: optionDetails.option
                    };

                    if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
                        showResponse = true;
                    }

                    let hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0;
                    this.setState(
                        {
                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && optionDetails.option.enable_feedback,
                            hasBadges: hasBadges,
                            badgesCollected: hasBadges,
                            showFeedback: false,
                            handleCompletion: true,
                            propsUpdated: false,
                            showOptions: true,
                            questionChecked: true,
                            currentlyChecked: true,
                            showCheckBtn: false,
                            options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
                            showResponse: showResponse,
                            progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
                            responseData: Object.assign(
                                {}, this.state.responseData,
                                {
                                    responses: dataHelper.immutablePush(responses, response),
                                    latestResponse: optionDetails.option
                                }
                            )
                        }
                    );
                }else{
                    this.setState({
                        reviewMode: false,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_NOT_STARTED,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                            }
                        )
                    });
                }
            } else {
                this.setState({renderQuestions: true});
            }
        }else{
            this.setState({
                reviewMode: false,
                propsUpdated: true,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentStatus: objectConstants.STATUS_NOT_STARTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                    }
                )
            });
        }
    }

    randomiseOptions() {
        let options = Object.assign([], this.state.options);
        if (this.state.screenObject.randomise_options) {
            options = dataHelper.randomiseArray(options);
        }
        this.setState({
            options: options,
            leftOption: options[0],
            rightOption: options[1],
            showOptions: true,
            setDrags: this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,//
            focusedOption: options[0]
        });
        this.scrollToTop();
    }


    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.callbacks,
                {
                    scrollToTop: this.scrollToTop,
                    scrollToFeedback: this.scrollToFeedback,
                    scrollToSubmitBtn: this.scrollToSubmitBtn,
                    scrollOptionsToTop: this.scrollOptionsToTop
                }
            )
        });
    }

    scrollToTop() {
        let subScreenParent = this.props.callbacks.getSubScreenParent();
        let objectUserData = {};
        let screen_id = this.props.callbacks.getScreenId();
        if (appHelper.isDefined(subScreenParent)) {
            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
        } else {
            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
        }
        if (this.state.allowScroll && (objectUserData.status !== objectConstants.STATUS_COMPLETE)) {
            let question = this.refs[`${this.state.screenObject.asset_id}_question`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                scrollTo(question.offsetTop);
            }, objectConstants.SCROLL_TO);
        }
    }

    scrollToFeedback(feedbackPos) {
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + feedbackPos,true);
        }, objectConstants.SCROLL_TO, true);
    }

    scrollToSubmitBtn(submitBtnOffset) {
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + submitBtnOffset);
        }, objectConstants.SCROLL_TO);
    }

    scrollOptionsToTop(questionOptionsOffset) {

        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + questionOptionsOffset);
        }, objectConstants.SCROLL_TO);
    }

    scrollToProgression() {
        this.setState({canScrolltoProgression: false});
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let progressionBtn = this.refs[`${this.state.screenObject.asset_id}_progression_btn`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + progressionBtn.offsetTop);
        }, objectConstants.SCROLL_TO);
    }

    onOptionClick(event) {
        // console.log(this.state.responseData.latestResponse)
        let response = {
            selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
        };
        // console.log(response.selectedOption);
        this.setState({
            checkAnswers: true,
            responseData: Object.assign({}, this.state.responseData,
                {
                    //responses: dataHelper.immutablePush(this.state.responseData.responses, response),
                    latestResponse: Object.assign({}, response.selectedOption),
                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED,
                }
            ),
            enableCheckBtn: true,
            showOptions: true,
        });
        this.scrollToSubmitBtn();
    }

    setActiveOption(option) {
        let response = {
            selectedOption: option
        };

        if (this.state.responseData.latestResponse !== option) {
            this.setState({
                responseData: Object.assign({}, this.state.responseData, {
                    latestResponse: option
                })
            });
        }
    }

    getClass(option) {
        return appHelper.isDefined(this.state.responseData.latestResponse.option_id) && option.option_id === this.state.responseData.latestResponse.option_id ? "active" : "";
    }

    enableDrag() {
        this.setState({setDrags: false});
        let setActiveOption = this.setActiveOption;
        let checkAnswers = this.checkAnswers;
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let swipeCard = this.refs[`${this.state.screenObject.asset_id}_swipe_card`];
        let swipeCardContent = this.refs[`${this.state.screenObject.asset_id}_swipe_card_content`];
        let leftOption = Object.assign({}, this.state.leftOption);
        let rightOption = Object.assign({}, this.state.rightOption);
        let moveTo = 0;
        let questionHalfWidth = appHelper.isDefined(question) ? question.offsetWidth / 2 : '100%';
        let swipeCardHalfWidth = appHelper.isDefined(swipeCard) ?  swipeCard.offsetWidth / 2 : '100%';

        TweenLite.set(swipeCard, {clearProps: "all"});
        Draggable.create(swipeCard, {
            bounds: question,
            throwProps: false,
            lockAxis: true,
            type: "x",
            onDrag: function () {
                let dragPosX = this.x;
                this.y = 0;
                if (dragPosX < -30) {
                    setActiveOption(leftOption);
                } else if (dragPosX > 30) {
                    setActiveOption(rightOption);
                } else {
                    setActiveOption({});
                }


                //console.log(dragPosX);
            },
            onDragEnd: function () {

                let dragPosX = this.x;
                if (dragPosX < -30) {
                    this.disable();
                    //moveTo = 0 - (questionHalfWidth - swipeCardHalfWidth);
                    TweenLite.to(swipeCard, 0.3, {
                        x: moveTo,
                        y: 0,
                        onComplete: checkAnswers,
                        //onCompleteParams:[leftOption]
                    });
                } else if (dragPosX > 30) {
                    this.disable();
                    //moveTo = questionHalfWidth - swipeCardHalfWidth;
                    TweenLite.to(swipeCard, 0.3, {
                        x: moveTo,
                        y: 0,
                        onComplete: checkAnswers,
                        //onCompleteParams:[rightOption]
                    });
                } else {
                    TweenLite.to(swipeCard, 0.3, {
                        x: moveTo,
                        y: 0,
                        //onComplete: checkAnswers,
                        //onCompleteParams:[{}]
                    });
                }

            }
        });
    }

    checkAnswers() {
        this.setState({checkAnswers: false});
        let response = {
            selectedOption: this.state.responseData.latestResponse
        };
        let showResponse = false;
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback;
        if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
            showResponse = true;
        }

        let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback && !showResponse;
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;

        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED,
                    //latestResponse: Object.assign({}, this.state.responseData.latestResponse)
                }
            ),
            showResponse: showResponse,
            showFeedback: enable_feedback && !showResponse,
            focusOnFeedback: enable_feedback && !showResponse,
            skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN  && !showResponse,
            showProgression: (!enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || ( !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN)  && !showResponse,
            progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
            hasBadges: hasBadges,
            questionChecked: true,
            currentlyChecked: true,
            showOptions: true,
            checkPostXAPIResponse: true
        });
    }

    handleResponseComplete(){
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback;
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;

        if(this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({
                showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                hasBadges: appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback,
                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
                showProgression: (!enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || ( !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN)

            });
        }
    }

    hideOptions() {
        this.setState({hideOptions: false});
        let optionsListRef = this.refs[`${this.state.screenObject.asset_id}_optionList`];
        TweenLite.to(optionsListRef, 1, {
            height: 0,
            ease: Expo.easeInOut
        });//.eventCallback("onComplete", this.onHideComplete);
    }

    getSwipeClass() {
        return this.state.showFeedback ? `feedback-panel ${this.state.responseData.latestResponse.result}` : "swipe-card draggable";
    }


    handleResponse() {
        this.setState({hideFeedback: false});
        let latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
        let progressionRule = this.state.responseData.latestResponse.progression;
        if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        } else {
            this.setState(
                {
                    showFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow() && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                    focusOnFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
                    showOptions: true,

                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
                        }
                    )
                }
            );

        }
        this.handleProgression();
        //}

    }

    hasFeedbackToShow() {
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback;

        return enable_feedback;
    }

    handleProgression() {
        /*lorn
        let navigateToNextScreen = true;
        this.props.callbacks.onObjectComplete(progressionRule, this.state.screenObject.asset_id, this.state.responseData.latestResponse, navigateToNextScreen);*/
        this.setState({handleCompletion: false});
        if(!this.state.progressionHandled) {
            this.setState({progressionHandled: true});
            let enable_feedback = this.state.responseData.latestResponse.enable_feedback;
            let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;


            let progressionRule = this.state.responseData.latestResponse.progression;
            let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                index: this.props.index

            };

            this.props.callbacks.onObjectComplete(completionData);
        }
    }

    reattempt() {
        this.setState(
            {
                showFeedback: false,
                enableCheckBtn: false,
                showCheckBtn: false,
                ///revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
                showOptions: true,
                setDrags: true,
                currentlyChecked: false,
                focusedOption: this.state.options[0],
                updateFocus: true,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentAttempt: this.state.responseData.currentAttempt + 1,
                        currentStatus: objectConstants.STATUS_ATTEMPTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
                        latestResponse: Object.assign({}, {}),

                    }
                )
            }
        );
    }

    //REVEW POPUP
    onReviewObject(sourceId) {
        if (this.hasFeedbackToShow()) {
            let config = Object.assign({}, MULTIPLE_CHOICE_REVIEW_CONFIG,
                {
                    title: this.state.locale.label,
                    sourceId: sourceId
                }
            );
            //locale.title

            for (let i = 0; i < config.childComponents.length; i++) {
                let child = config.childComponents[i];
                child.componentProps = Object.assign({}, {
                    screenObject: this.state.screenObject,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
                        }
                    ),
                    callbacks: this.props.callbacks
                });
            }
            this.props.actions.setNewDialog(config);
        }
    }

    getOptionListClass() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "multiple-choice-option-list" : "swipe-options-list";

    }

    onPromptRevealed() {
    }

    getBgClass() {
        return this.state.showFeedback || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "no-padding" : "";
    }

    getSwipeContainerClass() {
        return this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "swipe" : "";
    }

    getStatusClass() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
    }

    getTabIndex() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback ? 0 : -1;
    }

    onPanelClick() {
        if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow()) {
            this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
        }
    }

    onKeyboardPanelClick(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
                this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
            }
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setFocusedOption() {
        this.setState({focusedOption: Object.assign({}, this.state.options[0])});
    }

    clearFocusedOption() {
        this.setState({focusedOption: Object.assign({}, {})});
    }

    getPrevOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.options[optionIndex - 1];
        if (optionIndex <= 0) {
            nextOption = this.state.options[this.state.options.length - 1];
        }

        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    getNextOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.options[optionIndex + 1];
        if (optionIndex === (this.state.options.length - 1)) {
            nextOption = this.state.options[0];
        }
        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    allowKeyAccessibility() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length) {
            return false;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
                    return false;
                }
            }
            return true;
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.allowKeyAccessibility()) {
                this.onOptionClick({target: {value: this.state.focusedOption.option_id}});
            } else {
                let responseData = this.state.responseData;
                if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
                    this.onReviewObject(`option_${this.state.focusedOption.option_id}`);
                }

            }
        }

        if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
            event.preventDefault();
            this.getNextOption();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            this.getNextOption();
        }
    }

    onFocusOnFeedback() {
        let focusEl = document.getElementById(`feedback_wrapper_${this.state.screenObject.asset_id}`);
        if(appHelper.isDefined(focusEl) && focusEl !== null) {
            focusEl.focus();
        }
        this.setState({focusOnFeedback: false});
    }

    setOptionCallbacks() {
        this.setState({
            optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
                setKeyboardAccessibility: this.setKeyboardAccessibility
            })
        });
    }

    setOptionFocus() {

        let focusEl = document.getElementById(`option_${this.state.focusedOption.option_id}`);
        focusEl.focus();
        this.setState({updateFocus: false});
    }

    enableProgression(progression_label) {
        let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
        let showProgression = !hasBadges;
        if(!this.props.callbacks.hasNextObject(this.props.index)){
            showProgression = !hasBadges && progressionType !== objectConstants.GO_TO_TYPE_SCREEN;
        }
        this.setState({
            showProgression: showProgression,
            hasBadges: hasBadges,
            progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
            canScrollToContinue: true,
            canScrolltoProgression: true,
        });

    }

    onProgressionClicked() {
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback;

        this.setState({
            showProgression: false,
            hideFeedback: this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
        });

        if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.props.callbacks.navigateToNextScreen();
        } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        }
    }

    onBadgeCollected() {

        this.setState({badgesCollected: true});
        if(!this.props.callbacks.hasNextObject(this.props.index)){
            this.setState({
                showProgression: true,
                canScrollToContinue: true,
                canScrolltoProgression: true,
                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
            });
        }
        this.handleResponse();


        //this.hide();
    }
    show() {
        let questionRef = this.refs[`swipeContainer_${this.state.screenObject.asset_id}`];
        if(appHelper.isDefined(questionRef)) {
            TweenLite.set(questionRef, {height: "auto"});
            TweenLite.from(questionRef, objectConstants.SHOW_PANEL_DURATION, {
                height: 0,
                ease: Expo.easeInOut
            }).eventCallback("onComplete", this.scrollToTop);
        }
    }

    scrollToContinue(){
        this.setState({canScrollToContinue: false});
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop,true);
        }, objectConstants.SCROLL_TO);
    }
    render() {
        return (
            <div className="learner-action" ref={`${this.state.screenObject.asset_id}_question`}>
                <p className="hidden-el">{this.state.multiple_choice_single_answer_question_label}</p>
                {
                    appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                        ?
                        <div className={`content-character-expression`}>
                            <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                        </div>
                        :
                        null
                }
                <div className={`question-wrapper ${this.getStatusClass()}`} tabIndex={this.getTabIndex()}
                     id={`question_wrapper_${this.state.screenObject.asset_id}`}
                     role="presentation" onClick={this.onPanelClick} onKeyDown={this.onKeyboardPanelClick}>
                    <div className="swipe-container" ref={`swipeContainer_${this.state.screenObject.asset_id}`}>
                        {
                            this.state.screenObject.show_title && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
                                ? <div className={`object-container no-btm-margin`}><h4
                                    dangerouslySetInnerHTML={{__html: this.state.locale.label}}/></div>
                                : null
                        }


                        {
                            this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
                                ?
                                <div className={`object-container`} ref={`prompt_${this.state.screenObject.asset_id}`}>
                                    <div className={`question-prompt`}>
                                        <div className="content-column">
                                            {
                                                this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0
                                                    ? <h4 className="bold"
                                                          dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                                    : null
                                            }
                                            {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                                ?
                                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                        }
                        <div className={`swipe-bg ${this.getBgClass()}`}>
                            <div className={this.getSwipeContainerClass()}>

                                {this.state.showOptions
                                    ?
                                    <div className={`${this.getOptionListClass()}`}
                                         id={`${this.state.screenObject.asset_id}_questionOptions`}
                                         ref={`${this.state.screenObject.asset_id}_questionOptions`}
                                         role="radiogroup">
                                        {this.state.options.map(option =>
                                            <Option key={option.option_id}
                                                    option={option}
                                                    asset_id={this.state.screenObject.asset_id}
                                                    questionChecked={this.state.questionChecked}
                                                    currentlyChecked={this.state.currentlyChecked}
                                                    onOptionClick={this.onOptionClick}
                                                    responseData={this.state.responseData}
                                                    className={this.getClass(option)}
                                                //onAttemptComplete={this.showFeedback}
                                                //onOptionRevealed={this.onOptionRevealed}
                                                    focusedOption={this.state.focusedOption}
                                                    onReviewObject={this.onReviewObject}
                                                    index={appHelper.getObjectOptionIndex(this.state.screenObject.options, option.option_id)}
                                                    showFeedback={appHelper.isDefined(this.state.responseData.latestResponse.enable_feedback) && this.state.responseData.latestResponse.enable_feedback}
                                                    optionCallbacks={this.state.optionCallbacks}
                                            />
                                        )}
                                    </div>
                                    :
                                    null
                                }
                                {
                                    this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
                                        ?
                                        <div className={`${this.getSwipeClass()}`}
                                             ref={`${this.state.screenObject.asset_id}_swipe_card`}>
                                            <div className="swipe-card-content"
                                                 ref={`${this.state.screenObject.asset_id}_swipe_card_content`}
                                                 dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                        </div>
                                        : null
                                }
                            </div>

                        </div>
                    </div>
                    {this.state.showResponse
                        ?
                        <Conversation asset_id={this.state.screenObject.asset_id} option_id={this.state.responseData.latestResponse.option_id}
                                      dialogs={this.state.responseData.latestResponse.dialogs} callbacks={this.props.callbacks} onComplete={this.handleResponseComplete}/>
                        :
                        null
                    }

                    {
                        this.state.showFeedback
                            ? <div ref={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                   id={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                   role="article"
                                   tabIndex={0}
                                   className={`${this.getSwipeClass()}`}>
                                <Feedback screenObject={this.state.screenObject}
                                          option={this.state.responseData.latestResponse}
                                          options={this.state.screenObject.options}
                                          asset_id={this.state.screenObject.asset_id}
                                          responseData={this.state.responseData}
                                          onComplete={this.handleResponse}
                                          onShowReview={this.onReviewObject}
                                          onEnableProgression={this.enableProgression}
                                          hideFeedback={this.state.hideFeedback}
                                          index={this.props.index}
                                          callbacks={this.state.callbacks}/>
                            </div>
                            : null
                    }
                    {(this.state.showResponse || this.state.showFeedback) && this.state.hasBadges
                        ?
                        <br/>
                        :
                        null
                    }
                    {
                        this.state.hasBadges
                            ?
                            <div className="badge-wrapper">
                                {this.state.responseData.latestResponse.badges.map(badge =>
                                    <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                  bite_id={this.props.callbacks.getBiteId()}
                                                  asset_id={this.state.screenObject.asset_id}
                                                  onCollected={this.onBadgeCollected}
                                                  animate={this.state.animateBadge}
                                    />
                                )}
                            </div>
                            : null
                    }
                </div>
                {this.state.showProgression
                    ?
                    <div ref={`${this.state.screenObject.asset_id}_progression_btn`}>
                        <Button label={this.state.progression_label} id={`${this.state.screenObject.asset_id}_button`}
                            onClick={this.onProgressionClicked}/>
                    </div>
                    : null

                }
            </div>

        );
    }
}

SwipeHorizontal.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

SwipeHorizontal.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SwipeHorizontal);



/** WEBPACK FOOTER **
 ** ./src/components/objects/swipeHorizontal/SwipeHorizontal.js
 **/